// AI-CONTEXT: See docs/test-runs/2026-10-20-rapportage-per-deelnemer.md (B1)
// Nodig omdat de onderzoekkeuze van de onderzoekwidget alle onderzoeken van de
// organisatie toont, en een rapport over één deelnemer alleen iets laat zien
// bij de onderzoeken waarin die deelnemer antwoorden heeft.

/** Achter de naam van een onderzoek waarin de deelnemer antwoorden heeft. */
export const ANSWERED_MARK = '· antwoorden van deze deelnemer';

/**
 * @typedef {object} SelectOption
 * @property {string} value - Research `ID`
 * @property {string} label - Naam van het onderzoek
 */

/**
 * Zet de onderzoeken met antwoorden van de deelnemer bovenaan, met een
 * markering achter de naam; de rest volgt in de oude volgorde.
 *
 * @param {SelectOption[]} choices - Alle onderzoeken, in de volgorde van de keuzelijst
 * @param {Set<string>|null} answeredIds - Research `ID`'s met antwoorden; `null` = nog niet bekend
 * @returns {SelectOption[]}
 */
const orderResearchChoices = (choices, answeredIds) => {
    if (!answeredIds || answeredIds.size === 0) return choices;
    const answered = choices
        .filter(c => answeredIds.has(c.value))
        .map(c => ({ ...c, label: `${c.label} ${ANSWERED_MARK}` }));
    const rest = choices.filter(c => !answeredIds.has(c.value));
    return [...answered, ...rest];
};

export default orderResearchChoices;
